import React, { FunctionComponent } from "react";
import { Stats } from "./component";

export const StatsContainer: FunctionComponent = () => {
  return <Stats />;
};
